import React from "react";
import { Modal } from "react-bootstrap";
import { FaDownload, FaUserEdit, FaUserPlus, FaTrashAlt } from "react-icons/fa";

const OptionsModal = ({ show, onHide, distributor, onEdit }) => {
  // Inline style objects
  const styles = {
    modalBody: {
      padding: "20px",
    },
    title: {
      fontSize: "18px",
      fontWeight: "700",
      marginBottom: "10px",
      color: "#32a877ff",
    },
    subtitle: {
      fontSize: "13px",
      color: "#777",
      marginBottom: "15px",
    },
    optionsList: {
      display: "flex",
      flexDirection: "column",
      gap: "10px",
    },
    optionItem: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      padding: "10px",
      borderRadius: "10px",
      background: "#f8f8f8",
      cursor: "pointer",
      transition: "all 0.2s ease",
      border: "1px solid #eee",
    },
    optionItemHover: {
      background: "#f0e6f9",
    },
    optionIcon: {
      fontSize: "22px",
      color: "#32a877ff",
      minWidth: "25px",
    },
    optionText: {
      margin: 0,
      display: "flex",
      flexDirection: "column",
    },
    optionTitle: {
      fontSize: "14px",
      fontWeight: "600",
      marginBottom: "2px",
    },
    optionDescription: {
      fontSize: "12px",
      color: "#666",
      margin: 0,
    },
  };

  // Helper function for hover style
  const handleHover = (e, hover) => {
    Object.assign(
      e.currentTarget.style,
      hover ? styles.optionItemHover : { background: "#f8f8f8" }
    );
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={styles.title}>Action Options</Modal.Title>
      </Modal.Header>
      <Modal.Body style={styles.modalBody}>
        <p style={styles.subtitle}>Select an Option from below list</p>

        <div style={styles.optionsList}>
         {/* Edit Distributor */}
        <div
        style={styles.optionItem}
        onMouseEnter={(e) => handleHover(e, true)}
        onMouseLeave={(e) => handleHover(e, false)}
        onClick={() => {
            if (onEdit) onEdit(distributor);   // <-- tell parent to open edit modal with distributor
            if (onHide) onHide();              // <-- close this options modal
        }}
        >
        <FaUserEdit style={styles.optionIcon} />
        <div style={styles.optionText}>
            <span style={styles.optionTitle}>Edit Distributor</span>
            <span style={styles.optionDescription}>
            Select this Option to Edit Distributor
            </span>
        </div>
        </div>

          {/* Delete Distributor */}
          <div
            style={styles.optionItem}
            onMouseEnter={(e) => handleHover(e, true)}
            onMouseLeave={(e) => handleHover(e, false)}
            onClick={() => console.log("Delete Distributor")}
          >
            <FaTrashAlt style={styles.optionIcon} />
            <div style={styles.optionText}>
              <span style={styles.optionTitle}>Delete Distributor</span>
              <span style={styles.optionDescription}>
                Select this Option to Delete Distributor
              </span>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default OptionsModal;
